import { Component, effect, Inject, input, output, signal } from '@angular/core';
import { JSBridgeService } from '../jsbridge.service';
import { ServerAPI } from '../../serverapi';
import { KopModulesService } from '../../modules/kop-modules.service';
import { format } from "date-fns";
import { Zippable, zipSync } from 'fflate';
import { Router } from '@angular/router';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { downloadData } from '../../utils/utils';

@Component({
  selector: 'unlock',
  templateUrl: './unlock.component.html',
  styleUrl: './unlock.component.scss'
})
export class UnlockComponent {

  public filesToWatch: string[] = [];
  public fileInfos: Record<string, Date> = {};

  constructor(public jsBridgeService: JSBridgeService, @Inject('ServerApi') public serverApi: ServerAPI,
    public kopModulesService: KopModulesService, private router: Router, private dialogService: DialogService) {
    effect(async () => {
      if (this.isEditing()) {
        await this.getFileInfos();
        this.canWrite = await serverApi.canWriteKlant(jsBridgeService.getKlantNo());
      }
    });
  }

  public isEditing = input<boolean>(false);
  public onDone = output<boolean>();
  public opmerking = signal('');
  public unlockResult = '';
  public unlockError = false;
  public uren: string = '';
  public unlockAsSercom: boolean = false;

  private async getFileInfos() {
    let klantNo = this.jsBridgeService.getKlantNo();
    this.filesToWatch = [`SXB/${klantNo}.SXB`, `HEX/${klantNo}.HEX`, `PCI/${klantNo}.BIN`, `LST/${klantNo}.LST`,
    `MBUS/generated/${klantNo}.MBUS`, `MBUS/generated/${klantNo}.MBUS.txt`];
    this.fileInfos = await this.serverApi.getFileInfos(this.filesToWatch);

  }


  public getLastDate(f: string) {
    if (this.fileInfos[f] != undefined) {
      let dt = this.fileInfos[f];
      return format(dt, 'Pp (OOO)');
    }
    return undefined;
  }

  public canWrite: boolean = false;

  public async download(f: string) {
    let data = await this.serverApi.getFile(f);
    let parts = f.split('/');
    let name = parts[parts.length - 1];
    if (data != undefined) {
      downloadData(data, name);
    }
  }

  public async downloadAll() {
    let files: Zippable = {};
    for (let f of this.filesToWatch) {
      let data = await this.serverApi.getFile(f);

      if (data != undefined && data.length > 0) {
        const fileName = f.split(/[\\/]/).pop();

        if (fileName) {
          files[fileName] = [data, { level: 2 }];
        }
      }
    }
    let zip = zipSync(files);
    let klantNo = this.jsBridgeService.getKlantNo();

    let blob = new Blob([zip], { type: 'application/octet-stream' });
    let url = URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;

    a.download = `${klantNo}.zip`;
    a.click();

  }

  public disableUnlock: boolean = false;


  public async unlock() {
    this.disableUnlock = true;
    this.unlockError = false;

    try {
      this.unlockResult = "Unlocking .....";
      let klantNo = this.jsBridgeService.getKlantNo();
      let opmerkingShort = this.opmerking().substring(0, 200);
      await this.kopModulesService.save("", false);
      let newKlantNo = await this.serverApi.checkAndRenameNewKop(klantNo);
      let newKop = false;
      if (newKlantNo != klantNo) {
        newKop = true;
        this.jsBridgeService.changedKlantNo(newKlantNo);
        this.jsBridgeService.moveFile(`SXB/${klantNo}.SXB`, `SXB/${newKlantNo}.SXB`);
        klantNo = newKlantNo;
      }
      await this.jsBridgeService.compileBin();
      await this.jsBridgeService.compilePCIBBin();
      await this.jsBridgeService.generateKopList();
      try {
        let result = await this.serverApi.unlock(`SXB/${klantNo}.SXB`, {
          klantNo: klantNo,
          opmerking: this.opmerking(),
          uren: this.uren,
          unlockAsSercom: this.unlockAsSercom

        });
        if (result?.success) {
          await this.jsBridgeService.unlock();
          if (result.volgNummer != undefined) {
            this.jsBridgeService.updateVolgNummer(result.volgNummer);
            await this.kopModulesService.save("Unlock: " + opmerkingShort);
            await this.jsBridgeService.saveFile(`HEX/${klantNo}.HEX`);
            await this.jsBridgeService.saveFile(`BIN/${klantNo}.BEN`);
            await this.jsBridgeService.saveFile(`PCI/${klantNo}.BIN`);
            await this.jsBridgeService.saveFile(`LST/${klantNo}.LST`);
            await this.jsBridgeService.saveFile(`LST/${klantNo}.DBL`);
          }
        } else {
          this.unlockError = true;
        }
        this.unlockResult = JSON.stringify(result, undefined, 2);
        await this.getFileInfos();
        if (result?.success && newKop) {
          this.router.navigate([`SXB/${newKlantNo}`]);
        }
      } catch (e: any) {
        this.unlockResult = "Unlock mislukt!"
        this.unlockError = true;
      }
      if (this.unlockError) {
        const dialog: DialogRef = this.dialogService.open({
          title: `Unlock mislukt!`,
          content: `Unlock mislukt!`,
          actions: [{ text: "Close", id: "yes", themeColor: "primary" }],
        });
      }

    } catch (e) {
      this.unlockError = true;
      this.unlockResult = "Unlock mislukt!"
      return;
    }

    this.disableUnlock = false;

  }

  public close() {
    this.unlockError = false;
    this.unlockResult = "";
    this.onDone.emit(false);
  }
}
